import { render, staticRenderFns } from "./Example.vue?vue&type=template&id=15a10b8e&scoped=true&"
import script from "./Example.vue?vue&type=script&lang=js&"
export * from "./Example.vue?vue&type=script&lang=js&"
import style0 from "./Example.vue?vue&type=style&index=0&id=15a10b8e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a10b8e",
  null
  
)

export default component.exports